// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Spinner from './Spinner';

// Styles
import './BoardOperationSpinner.scss';

/**
 * Used when clearing templates or re-syncing boards.
 */
const BoardOperationSpinner = (props) => {
    const { children, className } = props;

    return (
        <div className={classNames('BoardOperationSpinner', className)}>
            <div className="loader-body">
                <Spinner show />

                {children}
            </div>
        </div>
    );
};

BoardOperationSpinner.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
};

export default BoardOperationSpinner;
